import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {DashboardComponent} from "./pages/dashboard.component";
import {DashboardRoutingModule} from "./dashboard-routing.module";
import {NgApexchartsModule} from "ng-apexcharts";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatNativeDateModule} from "@angular/material/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatMenuModule} from '@angular/material/menu';
import {MatSelectModule} from "@angular/material/select";
import {MatChipsModule} from '@angular/material/chips';
import {DialogFilterComponent} from './pages/dialog-filter/dialog-filter.component';
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";

@NgModule({
  declarations: [DashboardComponent, DialogFilterComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    MatMenuModule,
    MatSelectModule,
    MatChipsModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [MatDatepickerModule]
})
export class DashboardModule {
}
